var map = {
	"./block-accordion/_index.js": "./blocks/block-accordion/_index.js",
	"./block-banner-slider/_index.js": "./blocks/block-banner-slider/_index.js",
	"./block-books-slider/_index.js": "./blocks/block-books-slider/_index.js",
	"./block-clothes-slider/_index.js": "./blocks/block-clothes-slider/_index.js",
	"./block-digital-values/_index.js": "./blocks/block-digital-values/_index.js",
	"./block-digital-values/generateMagicCode.js": "./blocks/block-digital-values/generateMagicCode.js",
	"./block-digital-values/generateMagicSoundCode.js": "./blocks/block-digital-values/generateMagicSoundCode.js",
	"./block-parallax-trip/_index.js": "./blocks/block-parallax-trip/_index.js",
	"./block-reviews-slider/_index.js": "./blocks/block-reviews-slider/_index.js",
	"./block-signup-trip/_index.js": "./blocks/block-signup-trip/_index.js",
	"./block-signup/Signup.js": "./blocks/block-signup/Signup.js",
	"./block-signup/_index.js": "./blocks/block-signup/_index.js",
	"./block-slider/_index.js": "./blocks/block-slider/_index.js",
	"./block-template/_index.js": "./blocks/block-template/_index.js",
	"./block-w-photos/_index.js": "./blocks/block-w-photos/_index.js",
	"./block-youtube/_index.js": "./blocks/block-youtube/_index.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./blocks sync recursive \\.js$";